export default {
  operatedBy: 'Flys delvis av',
  partlyOperatedBy: 'Partly operated by',
  operatedByGerman: '',
}
